type FileLoader = (text: string) => void

export function bindFileInput(
  openBtn: HTMLButtonElement,
  fileInput: HTMLInputElement,
  dropTarget: HTMLElement,
  onLoad: FileLoader,
  onError: (msg: string) => void,
): void {
  openBtn.addEventListener('click', () => fileInput.click())

  fileInput.addEventListener('change', () => {
    const file = fileInput.files?.[0]
    if (file) readFile(file, onLoad, onError)
    fileInput.value = ''
  })

  dropTarget.addEventListener('dragover', (e) => {
    e.preventDefault()
    dropTarget.classList.add('drag-over')
  })
  dropTarget.addEventListener('dragleave', () => {
    dropTarget.classList.remove('drag-over')
  })
  dropTarget.addEventListener('drop', (e) => {
    e.preventDefault()
    dropTarget.classList.remove('drag-over')
    const file = e.dataTransfer?.files?.[0]
    if (file) readFile(file, onLoad, onError)
  })
}

function readFile(
  file: File,
  onLoad: FileLoader,
  onError: (msg: string) => void,
): void {
  const reader = new FileReader()
  reader.onload = () => {
    const result = reader.result
    if (typeof result === 'string') onLoad(result)
    else onError('File could not be read as text')
  }
  reader.onerror = () => {
    onError(`File read failed: ${reader.error?.message ?? 'unknown error'}`)
  }
  reader.readAsText(file, 'utf-8')
}
